<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Copy khóa học V4</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="source" label="Mã copy khóa học nguồn" class="form-item">
              <el-input v-model="modelData.source" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="destination" label="Mã copy khóa học đích" class="form-item">
              <el-input v-model="modelData.destination" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'CourseCreate',
  metaInfo () {
    return {
      title: 'Khóa học'
    }
  },
  components: {
    tinymce
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        source: '',
        destination: ''
      },
      lists: {
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ],
        listUniversity: [
          {key: 0, value: 'Không thuộc trường nào'},
          {key: 1, value: 'Trường Học Viện Ngân Hàng'},
          {key: 2, value: 'Trường Kinh Tế Quốc Dân'}
        ],
        listRank: [
          {key: 0, value: 'Chưa xếp hạng'},
          {key: 1, value: 'Người mới học'},
          {key: 2, value: 'Trung bình'},
          {key: 3, value: 'Nâng cao'}
        ],
        listTypeCourse: [
          {key: 0, value: 'Khóa học kĩ năng'},
          {key: 1, value: 'Khóa học đào tạo'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: []
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'courses/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        source: [
          { required: true, message: 'Vui lòng nhập mã khóa học đào tạo nguồn' },
          { min: 2, max: 191, message: 'Mã khóa học có chiều dài từ 2 tới 191 kí tự' }
        ],
        destination: [
          { required: true, message: 'Vui lòng nhập mã khóa học đào tạo đích' },
          { min: 2, max: 191, message: 'Mã khóa học có chiều dài từ 2 tới 191 kí tự' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      // let formData = new FormData()
      // formData.append('file', file.blob())
      // let response = await axios.post('courses/upload', formData)
      // if (response.code === 1) {
      //   success(response.data.path)
      // } else {
      //   return false
      // }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-create', text: 'Sao chép' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'courses-index'})
    },
    // Fetch dữ liệu về lĩnh vực khóa học
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      let data = {
        'status': 1,
        'limit': -1,
        'user_type': 2
      }
      axios.get('users', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về trường đại học
    fetchListUniversitiy () {
      axios.get('universities', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listUniversity = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'level_id': this.modelData.level_id
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.modelData.school_id,
        'level_id': this.modelData.level_id,
        'facult_id': this.modelData.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmDeleteModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel () {
      this.$confirm('Thực hiện copy? Toàn bộ bài giảng, đề thi của khóa học học đích sẽ bị đè mới ?', 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.storeModel()
      }).catch(() => {

      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('courses/copy-course-v4', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Sao chép thành công',
              type: 'success'
            })
            // this.$router.push({name: 'courses-index'})
            this.$refs['createModel'].resetFields()
            this.modelData.source = ''
            this.modelData.destination = ''
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh khóa học có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  },
  watch: {
    'modelData.type': function () {
      if (this.modelData.type === 1) {
        this.modelData.school_id = ''
        this.modelData.level_id = ''
        this.modelData.facult_id = ''
        this.modelData.specialized_id = ''
        this.modelData.category_course_id = ''
      }
    },
    'modelData.school_id': function () {
      if (this.modelData.school_id) {
        this.modelData.level_id = ''
        this.modelData.facult_id = ''
        this.modelData.specialized_id = ''

        this.lists.listLevel = []
        this.lists.listFacult = []
        this.lists.listSpecialized = []
        this.fetchLevel()
        this.fetchListTeacher()
      }
    },
    'modelData.level_id': function () {
      if (this.modelData.level_id) {
        this.modelData.facult_id = ''
        this.modelData.specialized_id = ''

        this.lists.listFacult = []
        this.lists.listSpecialized = []
        this.fetchFacult()
      }
    },
    'modelData.facult_id': function () {
      if (this.modelData.facult_id) {
        this.modelData.specialized_id = ''

        this.lists.listSpecialized = []
        this.fetchSpecialized()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/courses/Copy.vue